import {
  signInWithEmailAndPassword,
  signOut as firebaseSignOut,
  sendPasswordResetEmail as firebaseSendPasswordResetEmail,
  type User,
} from 'firebase/auth';
import type { Claims, Role } from '@helios/authz';
import { getAuthInstance } from './firebase-init';
import { mapAuthError } from './errors';

export async function signInWithEmailPassword(email: string, password: string): Promise<User> {
  try {
    const auth = getAuthInstance();
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    return userCredential.user;
  } catch (error: unknown) {
    const code =
      error && typeof error === 'object' && 'code' in error ? (error.code as string) : 'unknown';
    throw new Error(mapAuthError(code));
  }
}

export async function signOut(): Promise<void> {
  const auth = getAuthInstance();
  await firebaseSignOut(auth);
}

export async function getIdToken(forceRefresh = false): Promise<string | null> {
  const auth = getAuthInstance();
  const user = auth.currentUser;

  if (!user) return null;

  return user.getIdToken(forceRefresh);
}

export async function sendPasswordReset(email: string): Promise<void> {
  const auth = getAuthInstance();
  await firebaseSendPasswordResetEmail(auth, email);
}

export async function getClaims(user: User): Promise<Claims> {
  const idTokenResult = await user.getIdTokenResult();
  return {
    orgs: idTokenResult.claims.orgs as Record<string, { roles: Role[] }> | undefined,
    activeOrg: idTokenResult.claims.activeOrg as string | undefined,
    activeSuborg: idTokenResult.claims.activeSuborg as string | null | undefined,
  };
}
